import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';

@Component({
  selector: 'app-feed-create-post',
  templateUrl: './feed-create-post.component.html',
  styleUrls: ['./feed-create-post.component.scss'],
})
export class FeedCreatePostComponent implements OnInit {
  @Output() postCreated: EventEmitter<any> = new EventEmitter();
  loginEmail;
  showPost = false;
  user: any;
  userName: string;
  onSession: string;

  constructor(
    private loginSignupService: LoginSignupService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
    this.user = this.localStorageService.getItem('picture')
    this.userName = this.localStorageService.getItem('name')
    this.onSession = this.localStorageService.getItem('onSession')
  }

  createPostPopup() {
    if (
      this.loginEmail !== undefined &&
      this.loginEmail !== '' &&
      this.loginEmail !== null
    ) {
      this.showPost = true;
    } else {
      this.localStorageService.setItem("redirect_url",this.router.url);
      this.router.navigate(['/user/login']);
    }
  }

  postCreatedSuccess() {
    this.showPost = false;
    this.postCreated.emit();
  }
}
